<template>
	<div class="pb-1 mt-3">
    <p class="mb-0 body-1-4">{{$t('hotel.concierge.detail-guest-checkin')}}</p>
    <p class="mb-4 body-3-3-1"><span class="text-danger font-bold text-14">*</span> {{$t('hotel.concierge.form.mandatory-field')}}</p>

    <!-- PREFIX NAME -->
    <div class="my-3 pb-1">
      <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.title')}}<span class="text-danger">*</span></p>
      <v-select 
        class="general-select-border body-2-2 text-14 mb-1 text-capitalize" 
        @input="fillData"
        :options="gender_title" 
        :clearable="false"
        v-model="form.prefix_name">
        <template #selected-option="item">
          {{ $capitalize(item.label) }}
        </template>
        <template #option="item">
          {{ $capitalize(item.label) }}
        </template>
      </v-select>
    </div>

    <!-- NAME -->
    <div class="mb-3 pb-1">
      <div class="row slim-grid-row">
        <div class="col-6">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.first-name')}}<span class="text-danger">*</span></p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-0" :class="{'border-danger':show_error && error.first_name != ''}" placeholder="Jhon" v-model="form.first_name">
          <p class="mb-1 body-3-3-1 text-danger" v-if="show_error && error.first_name != ''">{{$t('warning-message.precheckin.'+error.first_name)}}</p>
        </div>
        <div class="col-6">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.last-name')}}</p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-1" v-model="form.last_name">
        </div>
        <div class="col-12">
          <p class="mb-0 body-2 font-regular text-12 sub-label">{{$t('hotel.concierge.form.name-instruction')}}</p>
        </div>
      </div>
    </div>

    <!-- NATIONALITY -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_nationality != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.nationality')}}<span class="text-danger" v-if="getMerchant.precheckin_form_nationality == 'REQUIRED'">*</span></p>
          <v-select 
            class="general-select-border body-2-2 text-14 mb-1"  
            :class="{'border-danger':show_error && error.nationality != ''}"
            label="name"
            @input="fillData"
            :clearable="false"
            :options="country.list" 
            v-model="country.nationality">
          </v-select>
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.nationality != ''">{{$t('warning-message.precheckin.'+error.nationality)}}</p>
        </div>
      </div>
    </div>

    <!-- DATE OF BIRTH -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_day_of_birth != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.date-of-birth')}}<span class="text-danger" v-if="getMerchant.precheckin_form_day_of_birth == 'REQUIRED'">*</span></p>
          <input 
            @change="fillData()" 
            data-inputmask="'mask': '99/99/9999','greedy' : false"
            type="text" 
            class="form-control body-2-2 text-14 mb-0 input-number-hide" 
            :class="{'border-danger':show_error && error.day_of_birth != ''}"
            placeholder="DD/MM/YYYY" 
            v-model="form.day_of_birth">
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.day_of_birth != ''">{{$t('warning-message.precheckin.'+error.day_of_birth)}}</p>
        </div>
      </div>
    </div>

    <!-- ID CARD NUMBER -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_id_card_number != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="align-self-end" :class="getMerchant.precheckin_form_id_card_expired_date != 'HIDE'?'col-7':'col-12'">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.id-card-number')}}<span class="text-danger" v-if="getMerchant.precheckin_form_id_card_number == 'REQUIRED'">*</span></p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-0" :class="{'border-danger':show_error && error.id_card_number != ''}" v-model="form.id_card_number">
          <p class="mb-1 body-3-3-1 text-danger" v-if="show_error && error.id_card_number != ''">{{$t('warning-message.precheckin.'+error.id_card_number)}}</p>
        </div>
        <div class="col-5 align-self-end" v-if="getMerchant.precheckin_form_id_card_expired_date != 'HIDE'">
          <div class="border-semi-grey rounded-6" style="padding: 10px;" :class="{'mb-22px':show_error && error.id_card_number != ''}">
            <div class="custom-control custom-checkbox mb-0">
              <input type="checkbox" @input="fillData" v-model="form.id_card_is_lifetime" class="custom-control-input" id="customCheck1">
              <label class="custom-control-label body-2-2" for="customCheck1">{{ $t('hotel.concierge.form.life-time-card') }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ID CARD NUMBER EXPIRED -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_id_card_expired_date != 'HIDE' && !form.id_card_is_lifetime">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.id-card-expiry-date')}}<span class="text-danger" v-if="getMerchant.precheckin_form_id_card_expired_date == 'REQUIRED'">*</span></p>
          <input 
            @change="fillData()" 
            data-inputmask="'mask': '99/99/9999','greedy' : false"
            type="text" 
            class="form-control body-2-2 text-14 mb-0 input-number-hide" 
            :class="{'border-danger':show_error && error.id_card_expired_date != ''}"
            placeholder="DD/MM/YYYY" 
            v-model="form.id_card_expired_date">
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.id_card_expired_date != ''">{{$t('warning-message.precheckin.'+error.id_card_expired_date)}}</p>
        </div>
      </div>
    </div>

    <!-- PHONE NUMBER -->
    <div class="my-3 pb-1">
      <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.phone-number')}}<span class="text-danger">*</span></p>
      <div class="row no-gutters concierge-dial-code-wrapper py-2" :class="{'concierge-dial-code-wrapper-active': country_code_focus,'border-danger':show_error && error.phone_number != ''}">
        <div class="col-2">
          <v-select
            :clearable="false"
            class="concierge-select-border" 
            @input="fillData"
            :options="country_code.list" 
            label="label" 
            v-model="country_code.selected">
              <template #selected-option="{ name, code }">
                <country-flag :country='code' size='normal'/>
              </template>
              <template v-slot:option="option">
                <div class="d-inline-block align-middle mr-2">
                  <country-flag :country='option.code' size='small'/>
                </div>
                <p class="mb-0 d-inline-block align-middle body-2-2">{{`${option.code} (${option.dial_code})`}}</p>
             </template>
          </v-select>
        </div>
        <div class="col-10">
          <p class="mb-0 body-2-2 pl-2 border-left d-inline-block align-middle mr-2">{{country_code.selected.dial_code}}</p>
          <input @change="fillData" type="text" @focus="country_code_focus = true" @blur="country_code_focus = false" class="border-0 p-0 m-0 body-2-2 d-inline-block align-middle" placeholder="XXXXXXXX" v-model="form.phone_number">
        </div>
      </div>
      <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.phone_number != ''">{{$t('warning-message.precheckin.'+error.phone_number)}}</p>
    </div>

    <!-- EMAIL -->
    <div class="my-3 pb-1">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.email')}}<span class="text-danger">*</span></p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-1" :class="{'border-danger':show_error && error.email != ''}" placeholder="example@guestapp.id" v-model="form.email">
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.email != ''">{{$t('warning-message.precheckin.'+error.email)}}</p>
        </div>
      </div>
    </div>

    <!-- RESIDENCE ADDRESS -->
    <div class="my-3 pb-1" v-if="getMerchant.precheckin_form_address != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.residence-address')}}<span class="text-danger" v-if="getMerchant.precheckin_form_address == 'REQUIRED'">*</span></p>
          <textarea @change="fillData" rows="2" type="text" class="form-control body-2-2 text-14 mb-1" :class="{'border-danger':show_error && error.address != ''}" v-model="form.address"></textarea>
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.address != ''">{{$t('warning-message.precheckin.'+error.address)}}</p>
        </div>
      </div>
    </div>

    <!-- TOWN & POST CODE -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_town != 'HIDE' || getMerchant.precheckin_form_postcode != 'HIDE'">
      <div class="row slim-grid-row">
        <div v-if="getMerchant.precheckin_form_town != 'HIDE'" :class="getMerchant.precheckin_form_postcode == 'HIDE'?'col-12':'col-6'">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.town')}}<span class="text-danger" v-if="getMerchant.precheckin_form_town == 'REQUIRED'">*</span></p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-0" :class="{'border-danger':show_error && error.town != ''}" v-model="form.town">
          <p class="mb-1 body-3-3-1 text-danger" v-if="show_error && error.town != ''">{{$t('warning-message.precheckin.'+error.town)}}</p>
        </div>
        <div v-if="getMerchant.precheckin_form_postcode != 'HIDE'" :class="getMerchant.precheckin_form_town == 'HIDE'?'col-12':'col-6'">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.post-code')}}<span class="text-danger" v-if="getMerchant.precheckin_form_postcode == 'REQUIRED'">*</span></p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-0" :class="{'border-danger':show_error && error.post_code != ''}" v-model="form.postcode">
          <p class="mb-1 body-3-3-1 text-danger" v-if="show_error && error.post_code != ''">{{$t('warning-message.precheckin.'+error.post_code)}}</p>
        </div>
      </div>
    </div>

    <!-- COUNTRY -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_country != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.country')}}<span class="text-danger" v-if="getMerchant.precheckin_form_country == 'REQUIRED'">*</span></p>
          <v-select 
            class="general-select-border body-2-2 text-14 mb-1" 
            :placeholder="$t('hotel.visitor-detail.country')" 
            label="name"
            @input="fillData"
            :clearable="false"
            :options="country.list" 
            v-model="country.country">
          </v-select>
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.country != ''">{{$t('warning-message.precheckin.'+error.country)}}</p>
        </div>
      </div>
    </div>

    <!-- PURPOSE OF VISIT -->
    <div class="my-3 pb-1" v-if="getMerchant.precheckin_form_purpose_of_visit != 'HIDE'">
      <div v-if="showVisitPurposeSelection" class="w-100" :class="visit_purpose_selected == 'Other'?'mb-3':''">
        <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.purpose-of-visit')}}<span class="text-danger" v-if="getMerchant.precheckin_form_purpose_of_visit == 'REQUIRED'">*</span></p>
        <v-select 
          class="general-select-border body-2-2 text-14 mb-1 text-capitalize" 
          :class="{'border-danger':show_error && error.visit_purpose != ''}"
          @input="fillData"
          :options="visit_purpose_list" 
          :clearable="false"
          v-model="visit_purpose_selected"></v-select>
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.visit_purpose != ''">{{$t('warning-message.precheckin.'+error.visit_purpose)}}</p>
      </div>
    
      <div class="row slim-grid-row" v-if="visit_purpose_selected == 'Other' || !showVisitPurposeSelection">
        <div class="col-12">
          <p v-if="showVisitPurposeSelection" class="mb-1 body-2-2">{{ $t('hotel.concierge.form.other-purpose-of-visit') }}<span class="text-danger">*</span></p>
          <p v-else class="mb-1 body-2-2">{{$t('hotel.concierge.form.purpose-of-visit')}}<span class="text-danger" v-if="getMerchant.precheckin_form_purpose_of_visit == 'REQUIRED'">*</span></p>
          
          <textarea @change="fillData" rows="2" type="text" class="form-control body-2-2 text-14 mb-1" :class="{'border-danger':show_error && error.visit_purpose != ''}" v-model="form.visit_purpose"></textarea>

          <p class="mb-3 body-3-3-1 text-danger" v-if="!showVisitPurposeSelection && show_error && error.visit_purpose != ''">{{$t('warning-message.precheckin.'+error.visit_purpose)}}</p>
        </div>
      </div>
    </div>

    <!-- SOURCE INFORMATION -->
    <div class="my-3 pb-1" v-if="getMerchant.precheckin_form_source_of_merchant_information != 'HIDE'">
      <div class="w-100" :class="form.source_of_merchant_information == 'Other source'?'mb-3':''">
        <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.source_of_merchant_information')}}<span class="text-danger" v-if="getMerchant.precheckin_form_source_of_merchant_information == 'REQUIRED'">*</span></p>
        <v-select 
          class="general-select-border body-2-2 text-14 mb-1 text-capitalize" 
          :class="{'border-danger':show_error && error.source_of_merchant_information != ''}"
          @input="fillData"
          :options="source_information_list" 
          :clearable="false"
          v-model="form.source_of_merchant_information"></v-select>
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.source_of_merchant_information != ''">{{$t('warning-message.precheckin.'+error.source_of_merchant_information)}}</p>
      </div>
      <div class="w-100" v-if="form.source_of_merchant_information == 'Other source'">
        <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.other-source')}}</p>
        <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-0" v-model="source_information_other">
      </div>
    </div>

    <!-- ALLERGIC -->
    <div class="my-3 pb-1" v-if="getMerchant.precheckin_form_allergy != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{ $t('hotel.concierge.form.allergic') }}<span class="text-danger" v-if="getMerchant.precheckin_form_allergy == 'REQUIRED'">*</span></p>
          <textarea @change="fillData" rows="2" type="text" class="form-control body-2-2 text-14 mb-1" :class="{'border-danger':show_error && error.allergy != ''}" v-model="form.allergy"></textarea>
          <p class="mb-3 body-3-3-1 text-danger" v-if="show_error && error.allergy != ''">{{$t('warning-message.precheckin.'+error.allergy)}}</p>
        </div>
      </div>
    </div>

    <!-- NEXT DESTINATION -->
    <div class="mb-3 pb-1" v-if="getMerchant.precheckin_form_next_destination != 'HIDE'">
      <div class="row slim-grid-row">
        <div class="col-12">
          <p class="mb-1 body-2-2">{{$t('hotel.concierge.form.next-destination')}}<span class="text-danger" v-if="getMerchant.precheckin_form_next_destination == 'REQUIRED'">*</span></p>
          <input @change="fillData" type="text" class="form-control body-2-2 text-14 mb-0" :class="{'border-danger':show_error && error.next_destination != ''}" v-model="form.next_destination">
          <p class="mb-1 body-3-3-1 text-danger" v-if="show_error && error.next_destination != ''">{{$t('warning-message.precheckin.'+error.next_destination)}}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
  import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import country from "@/data/country"
  import CountryFlag from 'vue-country-flag'
  import {formatDate} from '@/utils/index'
  import { parsePhoneNumber,parsePhoneNumberFromString } from 'libphonenumber-js'
  import moment from 'moment'
  import { mapGetters } from "vuex";

	export default{
    props:{
      guest:{
        type: Object,
        default: () => {}
      },
      is_auto_fill:{
        type: Boolean,
        default: false
      },
      error:{
        type: Object,
        default: () => {}
      },
      show_error:{
        type: Boolean,
        default: false
      }
    },
    components:{
      CountryFlag
    },
		data(){
			return{
        country_code_focus: false,
        country: {
          list: country,
          country: {},
          nationality: {}
        },
        form: {
          prefix_name: 'MR',
          first_name: '',
          last_name: '',
          nationality: '',
          day_of_birth: "",
          id_card_number: '',
          id_card_is_lifetime: false,
          id_card_expired_date: '',
          phone_number: '',
          email: '',
          address: '',
          town: '',
          postcode: '',
          country: '',
          visit_purpose: '',
          source_of_merchant_information: '',
          allergy: '',
          next_destination: ''
        },
        form_error:{
          phone_number: ''
        },
        country_code: {
          list: country,
          selected: {}
        },
        gender_title: ['MR', 'MRS', 'MISS', 'MS'],
        source_information_list: [
          "Friend's recommendation",
          "Social media",
          "Our website",
          "Internet",
          "Magazine/Newspaper",
          "Other source"
        ],
        source_information_other: '',
        visit_purpose_list: [],
        visit_purpose_selected: ''
			}
		},
    computed:{
      ...mapGetters(['getMerchant']),
      showVisitPurposeSelection(){
        return this.visit_purpose_list.length > 0
      }
    },
		created(){
      this.setupData()
		},
    mounted(){
      this.country.list = this.country.list.map(x=>{
        x.label = `${x.code}/${x.dial_code}`
        return x
      })
      
      $(document).ready(function(){
			  Inputmask().mask(document.querySelectorAll("input"));
			});
      this.fillData()
    },
		methods:{
      setupData(){
        // if(this.guest != undefined && Object.keys(this.guest).length > 0 && this.is_auto_fill){
        if(this.guest != undefined && Object.keys(this.guest).length > 0){
          this.form.first_name = this.guest.name
          this.form.email = this.guest.email
          this.form.id_card_is_lifetime = this.guest.id_card_is_lifetime
  
          this.form.prefix_name = this.$isNotEmpty(this.guest.prefix_name)  ? this.guest.prefix_name : 'MR'
          this.form.last_name = this.$isNotEmpty(this.guest.last_name)  ? this.guest.last_name : ''
          this.form.id_card_number = this.$isNotEmpty(this.guest.id_card_number)  ? this.guest.id_card_number : ''
          this.form.address = this.$isNotEmpty(this.guest.address)  ? this.guest.address : ''
          this.form.town = this.$isNotEmpty(this.guest.town)  ? this.guest.town : ''
          this.form.postcode = this.$isNotEmpty(this.guest.postcode)  ? this.guest.postcode : ''
          this.form.source_of_merchant_information = this.$isNotEmpty(this.guest.source_of_merchant_information)  ? this.guest.source_of_merchant_information : ''
          this.form.allergy = this.$isNotEmpty(this.guest.allergy)  ? this.guest.allergy : ''
  
          if(this.$isNotEmpty(this.guest.day_of_birth)){
            let date = moment(this.guest.day_of_birth,'YYYY-MM-DD').toDate()
            this.form.day_of_birth = `${moment(date).format("DD")}/${moment(date).format("MM")}/${moment(date).format("YYYY")}`
          }
          if(this.$isNotEmpty(this.guest.id_card_expired_date)){
            let date = moment(this.guest.id_card_expired_date,'YYYY-MM-DD').toDate()
            this.form.id_card_expired_date = `${moment(date).format("DD")}/${moment(date).format("MM")}/${moment(date).format("YYYY")}`
          }

          if(this.getMerchant.precheckin_form_purpose_of_visit != 'HIDE' && this.$isNotEmptyV2(this.getMerchant.precheckin_form_purpose_of_visit_choice)){
            this.visit_purpose_list = this.getMerchant.precheckin_form_purpose_of_visit_choice;
            this.visit_purpose_list.push("Other")
          }
          
  
          this.country.country = this.guest.country != null ? this.country.list.find(x=>x.name == this.guest.country) : {}
          this.country.nationality = this.guest.nationality != null ? this.country.list.find(x=>x.name == this.guest.nationality) : {}
  
          this.checkPhoneNumber(this.guest.phone)
        }else{
          this.country_code.selected = this.country_code.list.find(x=>x.code == 'ID')
        }
      },
      checkPhoneNumber(phone_number){
        if(phone_number == '#' || phone_number == '' || phone_number == undefined || phone_number == null){
          this.country_code.selected = this.country_code.list.find(x=>x.code == 'ID')
        }else{
          const phone_parsed = parsePhoneNumberFromString(phone_number)
          if (phone_parsed == undefined || typeof(phone_parsed) == 'undefined') {
            for(let i = 0; i < this.country_code.list.length; i++){
              let el = this.country_code.list[i]
              let check_country = parsePhoneNumber(phone_number,el.code)
              console.log(i)
              if(check_country.isValid()){
                this.country_code.selected = this.country_code.list.find(x => x.code == check_country.country)
                this.form.phone_number = check_country.nationalNumber
                break;
              }
              if(i+1 == this.country_code.list.length && !check_country.isValid()){
                console.log("Invalid phone number")
              }
            }
          }else{
            this.country_code.selected = this.country_code.list.find(x => x.code == phone_parsed.country)
            this.form.phone_number = phone_parsed.nationalNumber
          }
        }
      },
      formatDate(date){
        return formatDate(date)
      },
      fillData(){
        let params = this.$deepCopy(this.form)
        params.phone_number = this.country_code.selected.dial_code+this.form.phone_number
        params.country = this.country.country.name
        params.nationality = this.country.nationality.name
        params.day_of_birth = moment(this.form.day_of_birth,'DD/MM/YYYY').format("YYYY-MM-DD")
        params.id_card_expired_date = moment(this.form.id_card_expired_date,'DD/MM/YYYY').format("YYYY-MM-DD")
        if(this.form.source_of_merchant_information == 'Other source' && this.source_information_other != ''){
          params.source_of_merchant_information += `: ${this.source_information_other}`
        }
        if(this.showVisitPurposeSelection && this.visit_purpose_selected  != 'Other'){
          params.visit_purpose = this.visit_purpose_selected
        }
        this.$emit("fillData",{
          type: 'form',
          data: params
        })
      }
		}
	}
</script>
<style scoped>
	@media screen and (max-width: 992px) {
		.mobile-none{
			display: none !important;
		}
	}
  
  .border-green {
    border: 1px solid #79A33A !important;
  }

  .top-6px{
    top: 6px!important;
  }

  .h-check-in{
    height: 100vh;
    min-height: 100%
  }

  .concierge-dial-code-wrapper{
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .concierge-dial-code-wrapper input:focus{
    border: none !important;
  }

  .concierge-dial-code-wrapper-active{
    outline: none!important;
    box-shadow: 0px 4px 6px 0px #00000012!important;
    border-color: #79a33a!important;
  }
  .mb-22px{
    margin-bottom: 22px;
  }

</style>


// WEBPACK FOOTER //
// src/components/hotel/concierge/checkin/GeneralForm.vue